import { useRecoilState, useRecoilValue } from "recoil"
import projectStagesAtom from "../projectStages.atom"
import useHttpLoader from "shared/hooks/useHttpLoader"
import projectStagesApi from "../projectStages.api"
import projectStagesSelectors from "../projectStages.selectors"
import { IProjectStage } from "../projectTypes.types"
import { useEffect } from "react"

export const useProjectStagesState = () => {
  const [projectStagesState, setProjectStagesState] = useRecoilState(projectStagesAtom)
  const projectStagesMap = useRecoilValue(projectStagesSelectors.projectStagesMap)

  const { wait, loading } = useHttpLoader()

  const fetcher = () => {
    return projectStagesApi.getAll()
  }
  useEffect(() => {
    wait(fetcher(), (resp) => {
      if (resp.status === 'success') {
        setProjectStagesState(() => ({
          items: resp.body
        }))
      }
    })
  }, [])

  const addItem = (item: IProjectStage) => {
    setProjectStagesState(prev => ({ ...prev, items: [item, ...prev.items] }))
  }

  const updateItem = (updatedItem: IProjectStage) => {
    setProjectStagesState((prev) => ({
      ...prev,
      items: [updatedItem, ...prev.items.filter((item) => item.id !== updatedItem.id)],
    }))
  }
  
  return { projectStagesState, setProjectStagesState, projectStagesMap, loading, addItem, updateItem}
}